import React, { useState } from 'react';
import {
  Card, CardContent, TextField, Button, Typography, Grid,
  Alert, Box, Divider,
} from '@mui/material';
import Layout from '../components/Layout/Layout';
import PageHeader from '../components/Common/PageHeader';
import { updateProfileApi } from '../api/auth';
import { useAuth } from '../hooks/useAuth';
import { useDispatch } from 'react-redux';
import { updateUser } from '../store/authSlice';

export default function Profile() {
  const { user } = useAuth();
  const dispatch = useDispatch();
  const [form, setForm] = useState({
    name: user?.name || '',
    mobile_number: user?.mobile_number || '',
    company_name: user?.company_name || '',
    address: user?.address || '',
  });
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); setSuccess(false); setError('');
    try {
      const res = await updateProfileApi(form);
      dispatch(updateUser(res.data));
      setSuccess(true);
    } catch (err) {
      setError(JSON.stringify(err.response?.data) || 'Update failed.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout title="Profile">
      <PageHeader title="My Profile" />
      <Card sx={{ maxWidth: 560 }}>
        <CardContent>
          <Box sx={{ mb: 2 }}>
            <Typography variant="body2" color="text.secondary">Role</Typography>
            <Typography variant="body1" sx={{ fontWeight: 600, textTransform: 'capitalize' }}>{user?.role?.replace('_', ' ')}</Typography>
          </Box>
          <Box sx={{ mb: 2 }}>
            <Typography variant="body2" color="text.secondary">Email</Typography>
            <Typography variant="body1">{user?.email}</Typography>
          </Box>
          <Divider sx={{ mb: 2 }} />
          {success && <Alert severity="success" sx={{ mb: 2 }}>Profile updated successfully.</Alert>}
          {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
          <Box component="form" onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <TextField fullWidth label="Full Name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} required />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField fullWidth label="Mobile Number" value={form.mobile_number} onChange={(e) => setForm({ ...form, mobile_number: e.target.value })} />
              </Grid>
              {user?.role === 'publisher' && (
                <>
                  <Grid item xs={12}>
                    <TextField fullWidth label="Company Name" value={form.company_name} onChange={(e) => setForm({ ...form, company_name: e.target.value })} />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField fullWidth label="Address" multiline rows={2} value={form.address} onChange={(e) => setForm({ ...form, address: e.target.value })} />
                  </Grid>
                </>
              )}
            </Grid>
            <Button type="submit" variant="contained" disabled={loading} sx={{ mt: 2 }}>
              {loading ? 'Saving...' : 'Save Changes'}
            </Button>
          </Box>
        </CardContent>
      </Card>
    </Layout>
  );
}
